import { SelectOptionProps } from '@acceso/design-system';

import { useGetProgramsAudienceProgramSources } from '@/features/programs/api/get-audience-program-sources';

type Filters = {
  scopeIn?: string;
  mediaType?: string;
  name?: string;
  includeIds?: string[];
};

export function useAudienceProgramSourceOptions(filters?: Filters) {
  const { data: audienceProgramSources = [] } = useGetProgramsAudienceProgramSources({
    scopeIn: filters?.scopeIn,
    mediaType: filters?.mediaType,
    includeIds: filters?.includeIds,
    name: filters?.name,
  });
  const audienceProgramSourceOptions: SelectOptionProps<string>[] = audienceProgramSources.map(
    audienceProgramSource => ({
      label: audienceProgramSource.name,
      value: audienceProgramSource.id,
    })
  );

  return audienceProgramSourceOptions;
}
